import { useState } from 'react';
import apiClient from '../api/client';
import { toast } from 'react-hot-toast';

export default function ChangePasswordModal({ user, domain, onClose }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setError(null);
    if (!newPassword || !confirmPassword) return setError("Both fields are required");
    if (newPassword !== confirmPassword) return setError("Passwords do not match");
    if (newPassword.length < 8) return setError("Password must be at least 8 characters");

    setLoading(true);
    try {
      await apiClient.post(`/api/users/change-password`, {
        domain,
        userId: user.szUserId,
        companyId: user.szCompanyId,
        newPassword,
      });
      toast.success("Password changed successfully!");
      onClose();
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to change password";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 1060,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px'
    }} onClick={onClose}>
      
      <div style={{
        width: '100%', maxWidth: '400px', background: 'white', borderRadius: '10px',
        overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
      }} onClick={e => e.stopPropagation()}>

        <div style={{ 
          background: '#0aa375', color: 'white', padding: '12px 16px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: '15px' }}>Change Password</div>
              <div style={{ fontSize: '13px', marginTop: '2px' }}>
                {user.szUserName} | {user.szCompanyName}
              </div>
            </div>
            <button 
              onClick={onClose} 
              style={{ background: 'none', border: 'none', color: 'white', fontSize: '26px', marginTop: '-4px' }}
            >
              ×
            </button>
          </div>
          <div style={{ fontSize: '11px', opacity: 0.85, marginTop: '4px' }}>
            UID: {user.szUserId} | CID: {user.szCompanyId}
          </div>
        </div>

        <div style={{ padding: '16px' }}>
          {error && (
            <div style={{ color: '#dc3545', background: '#fff5f5', border: '1px solid #f5c6cb', borderRadius: '6px', padding: '8px 12px', marginBottom: '12px', fontSize: '12px' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '10px', fontWeight: 600, color: '#495057', marginBottom: '4px', display: 'block' }}>NEW PASSWORD</label>
            <input
              type="password"
              style={{ width: '100%', height: '36px', padding: '0 10px', border: '1px solid #dee2e6', borderRadius: '6px', fontSize: '13px' }}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Min. 8 characters"
              disabled={loading}
            />
          </div>

          <div style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '10px', fontWeight: 600, color: '#495057', marginBottom: '4px', display: 'block' }}>CONFIRM PASSWORD</label>
            <input
              type="password"
              style={{ width: '100%', height: '36px', padding: '0 10px', border: '1px solid #dee2e6', borderRadius: '6px', fontSize: '13px' }}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter password"
              disabled={loading}
            />
          </div>

          <div style={{ fontSize: '11px', color: '#6c757d' }}>
            Password must be at least 8 characters long.
          </div>
        </div>

        <div style={{ 
          padding: '10px 16px', borderTop: '1px solid #eee', 
          background: '#f8f9fa', display: 'flex', gap: '8px', justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            disabled={loading}
            style={{ 
              padding: '6px 16px', fontSize: '12.5px', background: '#6c757d', 
              color: 'white', border: 'none', borderRadius: '5px'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{ 
              padding: '6px 18px', fontSize: '12.5px', background: loading ? '#6c757d' : '#0aa375', 
              color: 'white', border: 'none', borderRadius: '5px', fontWeight: 600 
            }}
          >
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </div>
      </div>
    </div>
  );
}